'use strict';

var log = require('../../log/Log').channel('AudioSourceController');
var defaults = require('../../defaults/Defaults');
var sutl = require('../../sutl/Sutl');

angular.module('inara').controller('AudioSourceController', AudioSourceController);

AudioSourceController.$inject = ['$scope', 'RoomService', 
							     'ionicMaterialInk', '$timeout'];

function AudioSourceController($scope, RoomService,
						       ionicMaterialInk, $timeout) { 
    var vm = this;
    var room = null;
    var noDisplaySelectedIcon = 'ion-aveo-monitor';
    var audioInputIconLookup = {
        'audio_cable': 'ion-aveo-audio-cable',
        'laptop': 'ion-android-laptop',
        'radio': 'ion-aveo-radio',
        'room': 'ion-aveo-room',
        'tv': 'ion-aveo-monitor'
    };
    var uiAudioInputMutes = {};
    var userRequestedMute = null;
    var previousSources = null;

    log.info('initializing');

    vm.onSelectAudioInput = onSelectAudioInput;
    vm.isSelectedAudioInput = isSelectedAudioInput;
    vm.getAudioInputIcon = getAudioInputIcon;

    RoomService.onOnlineChanged(onRoomServiceOnlineChanged);
	ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });

    $scope.$on('$destroy', function() {
        RoomService.offOnlineChanged(onRoomServiceOnlineChanged);

        if (room !== null) {
            room.$offChange(onRoomChanged);
            room = null;
        }
    });

    function onRoomServiceOnlineChanged(online) {
        if (online) {
            room = RoomService.getRoom();
            room.$onChange(onRoomChanged);
        } else {
            if (room !== null) {
                room.$offChange(onRoomChanged);
                room = null;
                previousSources = null;
            }
            userRequestedMute = null;
        }
    }

    function onRoomChanged() {
        if (room === null || !RoomService.online()) return;

        var currentSources = room.configuredCaps.audioInputSources;

        if (previousSources === null ||
            !sutl.objEquals(previousSources, currentSources)) {
            previousSources = sutl.deepCopy(currentSources);
            vm.configuredAudioInputSources = angular.copy(room.configuredCaps.audioInputSources);
            vm.audioInputSources = room.caps.audioInputSources;
        }
        
        if (room.states.hasOwnProperty('audioInputSources')) {
            var sourceKeys = Object.keys(room.states.audioInputSources);
            for (var i = 0; i < sourceKeys.length; i++) {
                // If the user just requested that a source unmute, there may 
                // first be a room state change for another unmuted source
                // and we can skip changing the user requested source if it is
                // muted because the next response will then unmute it. This
                // avoids a flicker in the source selection in that case.
                if (sourceKeys[i] === userRequestedMute &&
                    room.states.audioInputSources[sourceKeys[i]].mute) {
                    continue;
                }
                uiAudioInputMutes[sourceKeys[i]] = 
                	room.states.audioInputSources[sourceKeys[i]].mute;
            }
        }
        else if (Object.keys(uiAudioInputMutes).length > 0) {
            uiAudioInputMutes = {};
        }
        userRequestedMute = null;
    }

    function onSelectAudioInput(audioInput) {
        if (room === null || !RoomService.online()) return;
        // set mutes for all other inputs
        for (var key in uiAudioInputMutes)  {
            if (uiAudioInputMutes.hasOwnProperty(key) &&
                key !== audioInput.$key) {
                uiAudioInputMutes[key] = true;
                room.$requestAudioInputMute(key, true);
            }
        }
        userRequestedMute = audioInput.$key;
        uiAudioInputMutes[audioInput.$key] = false;
        room.$requestAudioInputMute(audioInput.$key, false);
        log.debug('selected audio input: ' + audioInput.$key);
    }

    function isSelectedAudioInput(audioInput) {
        if (room === null || 
            !RoomService.online()) {
            return false;
        }

        return uiAudioInputMutes[audioInput.$key] === false;
    }

    function getAudioInputIcon(audioInput) {
        if (room === null || !RoomService.online()) return noDisplaySelectedIcon;
        var icon;
        if (audioInput) {
            icon = audioInputIconLookup[audioInput.icon];
        }
        return angular.isDefined(icon) ? icon : noDisplaySelectedIcon;
    }
}

module.exports = AudioSourceController;
